"use client";

/* eslint-disable react-hooks/exhaustive-deps */

import { useCallback, useEffect, useState } from "react";

export default function useAsync<T>(promiseFn: () => Promise<T> | void, deps: unknown[] = []) {
  const [data, setData] = useState<T | null | void>(null);
  const [error, setError] = useState<unknown | null>(null);

  const [loading, setLoading] = useState<boolean | null>(null);

  const mutate = useCallback(() => {
    setLoading(true);

    if (typeof promiseFn === "function") {
      Promise.resolve(promiseFn())
        .then(setData)
        .catch(setError)
        .finally(() => setLoading(false));
    }
  }, deps);

  useEffect(() => mutate(), [mutate]);

  return { ...(data as T), loading, error, mutate } as const;
}
